import { Fragment, useEffect } from "react";
import axios from "axios";
import apiMiddleware from "middlewares/apiMiddleware";
import useSWR from "swr";
export default function JwtAuthMiddleware({ children }) {
  const fetcher = (url) =>
    axios.post(url, { withCredentials: true }).then((res) => res.data);
  const {data, error} = useSWR("/auth", fetcher, { use: [apiMiddleware] });
  return <Fragment>{children}</Fragment>;
}
